require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-euro-repar-car-service.json") })
        }
      }, "path---authors-euro-repar-car-service");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-euro-repar-car-service!./.cache/json/authors-euro-repar-car-service.json
// module id = 1277
// module chunks = 231608221292675